import { createClient } from "@supabase/supabase-js";
import { Database } from "./types";
import { supabaseAnonKey, supabaseUrl } from "utils/env";

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  /**
   * Msw cannot intercept the default cross-fetch
   * @link https://github.com/supabase/supabase/issues/27656
   */
  ...(process.env.NODE_ENV === "test" ? { global: { fetch: (...args) => fetch(...args) } } : {}),
});
